import React from 'react';
export const Twitter = _ref => {
  let {
    color = 'currentColor',
    size = '16'
  } = _ref;
  return React.createElement("svg", {
    width: size,
    height: "100%",
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M14.372 3.663c0-.142-.003-.283-.01-.424A6.68 6.68 0 0 0 16 1.54a6.55 6.55 0 0 1-1.885.517A3.293 3.293 0 0 0 15.558.24a6.578 6.578 0 0 1-2.084.797A3.283 3.283 0 0 0 7.88 4.031 9.32 9.32 0 0 1 1.114.6 3.28 3.28 0 0 0 2.13 4.984a3.26 3.26 0 0 1-1.487-.411v.042a3.284 3.284 0 0 0 2.633 3.218 3.286 3.286 0 0 1-1.483.056 3.287 3.287 0 0 0 3.067 2.28A6.587 6.587 0 0 1 0 11.53a9.294 9.294 0 0 0 5.032 1.474c6.038 0 9.34-5.002 9.34-9.34z",
    fill: color
  }));
};